import type { ReactNode } from 'react'

interface Props {
  icon: ReactNode
  title: string
  description: string
  children?: ReactNode
  className?: string
}

export function PageState({ icon, title, description, children, className = '' }: Props) {
  return <div className={`page-state ${className}`.trim()}>
    <div className="page-state-icon">{icon}</div>
    <div className="page-state-copy">
      <strong>{title}</strong>
      <p>{description}</p>
    </div>
    {children && <div className="page-state-actions">{children}</div>}
  </div>
}
